<script>
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import {
  tax_fee_type,
  tax_rule_type,
  tax_rule_applied,
} from "@/helpers/global.variable";
import { required } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  name: "Taxes",
  props: {
    currentProps: Object,
  },
  data() {
    return {
      tax_fee_type,
      tax_rule_type,
      tax_rule_applied,
      submitted: false,
      taxForm: false,
      table: {
        tableData: [],
      },
      tax: {
        index: "",
        id: "",
        name: "",
        amount_or_percent: 0,
        fee_type: "fix_amount",
        rule_type: "per_stay",
        rule_applied: "at_booking",
        btn_text: "Add",
        is_edit: false,
      },
      is_data_loading: true,
      is_btn_loading: false,
      is_del_loading: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getTaxesList();
  },
  validations: {
    tax: {
      name: {
        required,
      },
      amount_or_percent: {
        required,
        // minLength: minLength(function () {
        //   if (this.fee_type == "fix_amount") {
        //     return "00.00";
        //   } else {
        //     return "00.01";
        //   }
        // }),
        // maxLength: maxLength(function () {
        //   if (this.fee_type == "fix_amount") {
        //     return "00.00";
        //   } else {
        //     return "99.99";
        //   }
        // }),
      },
      fee_type: {
        required,
      },
      rule_type: {
        required,
      },
      rule_applied: {
        required,
      },
    },
  },
  methods: {
    getTaxesList() {
      UserService.getTaxList().then((taxes) => {
        this.table.tableData = taxes;
      });

      this.is_data_loading = false;
    },
    hideForm() {
      this.submitted = false;
      this.taxForm = false;
      this.tax = {
        index: "",
        id: "",
        name: "",
        amount_or_percent: 0,
        fee_type: "fix_amount",
        rule_type: "per_stay",
        rule_applied: "at_booking",
        btn_text: "Add",
        is_edit: false,
      };
    },
    showForm() {
      this.taxForm = true;
    },
    onSubmit() {
      this.is_btn_loading = true;
      this.submitted = true;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let taxData = new FormData();
        taxData.append("hotel", this.hotel.id);
        taxData.append("name", this.tax.name);
        taxData.append("fee_type", this.tax.fee_type);
        taxData.append("amount_or_percent", this.tax.amount_or_percent);
        taxData.append("rule_applied", this.tax.rule_applied);
        taxData.append("rule_type", this.tax.rule_type);
        taxData.append("is_active", true);

        if (this.tax.is_edit) {
          UserService.editTax(this.tax.id, taxData).then(
            (tax) => {
              this.table.tableData[this.tax.index] = tax;
              this.is_btn_loading = false;
              this.submitted = false;
              Middleware.notification(
                "Successfully updated !!",
                "success",
                3000
              );
              this.hideForm();
            },
            (error) => {
              this.is_btn_loading = false;
              errorHandler(error);
            }
          );
        } else {
          UserService.createTax(taxData).then(
            (tax) => {
              this.table.tableData.push(tax);
              this.is_btn_loading = false;
              this.submitted = false;
              Middleware.notification("Successfully added !!", "success", 3000);
              this.hideForm();
            },
            (error) => {
              this.is_btn_loading = false;
              errorHandler(error);
            }
          );
        }
      }
    },

    // delete tax
    deleteTax(tax_id, index) {
      UserService.deleteTax(tax_id).then(
        () => {
          this.table.tableData.splice(index, 1);
          Middleware.notification("Successfully deleted !!", "danger", 3000);
        },
        (error) => {
          this.is_btn_loading = false;
          errorHandler(error);
        }
      );
    },

    // edit tax
    getEditTaxDetails(tax_id, index) {
      UserService.getTaxDetails(tax_id)
        .then((tax) => {
          this.tax.name = tax.name;
          this.tax.amount_or_percent = tax.amount_or_percent;
          this.tax.fee_type = tax.fee_type;
          this.tax.rule_type = tax.rule_type;
          this.tax.rule_applied = tax.rule_applied;
          this.tax.btn_text = "Edit";
          this.tax.id = tax_id;
          this.tax.index = index;
          this.tax.is_edit = true;
          this.showForm();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12 mt-2">
      <!-- Table -->
      <div class="table-responsive mb-0">
        <table class="table table-hover mb-0" ref="my-table">
          <thead class="table-light">
            <tr>
              <th width="20%">Label</th>
              <th colspan="4" width="65%">Fee</th>
              <th width="15%">Actions</th>
            </tr>
          </thead>
          <tbody id="infinite-list">
            <tr v-if="is_data_loading">
              <td class="placeholder-glow">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
              <td colspan="4" class="placeholder-glow">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
              <td class="placeholder-glow">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
            <template v-if="table.tableData.length > 0 && !is_data_loading">
              <tr v-for="(data, index) in table.tableData" :key="index">
                <td>{{ data.name }}</td>
                <td colspan="4">
                  {{ data.amount_or_percent }}
                  {{ data.fee_type == "percent" ? "%" : "$" }}
                  {{ data.rule_type.replace(/_/g, " ") }}
                  {{ data.rule_applied.replace(/_/g, " ") }}
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <a href="#">
                      <i
                        class="fas fa-pencil-alt ms-2 text-success"
                        v-b-popover.hover="'Edit'"
                        @click="getEditTaxDetails(data.id, index)"
                      ></i>
                    </a>
                    <a href="#">
                      <i
                        class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                        v-b-popover.hover="'Delete'"
                        @click="deleteTax(data.id, index)"
                      ></i>
                    </a>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="!is_data_loading && table.tableData.length == 0">
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
            <tr v-if="taxForm">
              <td>
                <b-form-input
                  id="name"
                  type="text"
                  autocomplete="off"
                  placeholder="Item"
                  v-model="tax.name"
                  :class="{
                    'is-invalid': submitted && $v.tax.name.$error,
                  }"
                ></b-form-input>
              </td>
              <td>
                <b-form-input
                  id="name"
                  type="number"
                  autocomplete="off"
                  placeholder="10"
                  :step="tax.fee_type == 'fix_amount' ? '1.00' : '00.01'"
                  :max="tax.fee_type == 'fix_amount' ? '' : '99.99'"
                  :min="tax.fee_type == 'fix_amount' ? '' : '00.01'"
                  v-model="tax.amount_or_percent"
                  :class="{
                    'is-invalid': submitted && $v.tax.amount_or_percent.$error,
                  }"
                ></b-form-input>
              </td>
              <td>
                <b-form-select
                  class="form-select"
                  v-model="tax.fee_type"
                  :options="tax_fee_type"
                  :class="{
                    'is-invalid': submitted && $v.tax.fee_type.$error,
                  }"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  class="form-select"
                  v-model="tax.rule_type"
                  :options="tax_rule_type"
                  :class="{
                    'is-invalid': submitted && $v.tax.rule_type.$error,
                  }"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  class="form-select"
                  v-model="tax.rule_applied"
                  :options="tax_rule_applied"
                  :class="{
                    'is-invalid': submitted && $v.tax.rule_applied.$error,
                  }"
                ></b-form-select>
              </td>
              <td>
                <b-button
                  size="sm"
                  variant="primary"
                  @click="onSubmit()"
                  :class="{ disabled: is_btn_loading }"
                >
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    v-if="is_btn_loading"
                  ></i>
                  {{ tax.btn_text }}
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="ms-1"
                  @click="hideForm()"
                >
                  Cancel
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-button size="sm" variant="primary" class="mt-3" @click="showForm()">
        Add New Tax
      </b-button>
    </div>
  </div>
</template>
